import { HTTP } from "../../http-common";

export const state = {
  viewbarEnabled: false,
  impersonating: {},
  loadingState: false
};

export const getters = {
  viewbarEnabled: state => {
    return state.viewbarEnabled;
  },
  impersonating: state => {
    return state.impersonating;
  },
  loadingState: state => {
    return state.loadingState;
  }
};

export const mutations = {
  RESET_IMPERSONATION(state) {
    state.impersonating = {};
    state.viewbarEnabled = false;
  },
  TOGGLE_VIEWBAR(state) {
    state.viewbarEnabled = !state.viewbarEnabled;
  },
  SET_IMPERSONATING(state, user) {
    state.impersonating = user;
  }
};

const actions = {
  getCurrentDealerCustomers() {
    return new Promise((resolve, reject) => {
      HTTP.get(`Impersonate/GetCurrentDealerCustomers`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getDealerMembers() {
    return new Promise((resolve, reject) => {
      HTTP.get(`Impersonate/GetDealerMembers`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  showLoading({ commit }) {
    commit("SHOW_LOADING");
  },
  hideLoading({ commit }) {
    commit("HIDE_LOADING");
  },

  processImpersonation({ state }) {
    let data = {
      userType: "dealer",
      impersonatedID: state.impersonating.dealerIDno
    };

    return new Promise((resolve, reject) => {
      HTTP.post(`Impersonate/Impersonate`, data)
        .then(data => {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  revokeImpersonation({ commit }) {
    let data = {
      userType: "dealer",
      impersonatedID: -1
    };

    return new Promise((resolve, reject) => {
      HTTP.post(`Impersonate/Impersonate`, data)
        .then(data => {
          commit("SET_IMPERSONATING", {});
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  toggleViewBar({ commit, state }) {
    commit("TOGGLE_VIEWBAR", !state.viewbarEnabled);
  },
  setImpersonatingAs({ commit }, user) {
    commit("SET_IMPERSONATING", user);
  },
  resetImpersonation({ commit, dispatch }) {
    dispatch("revokeImpersonation");
    commit("RESET_IMPERSONATION");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
